var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloud-Warning"},[_c('div',{staticStyle:{"width":"100%","height":"33vh","margin-top":"2vh"},attrs:{"id":"main_car"}})])
}]

export { render, staticRenderFns }